import http from '@/lib/axios';

/**
 * @description 登录初始化配置（登录方式、三方登录参数、商标信息）
 * @param {Record<'appId' | 'language', string>} params appId：游戏appid，language：zh-CN
 * @return {Promise<{ loginType: string; thirdPartyPara: JSON; brandInfo: Record<'brandLogoUrl' | 'brandName' | 'webTagBrandLogoUrl', string> }} loginType: 二级制字符串每一位代表一种三方
 */
export function oauthInit(params, config) {
    return http.post('web/basic/initialize', params, config);
}

/**
 * @description Twitter 1.0 获取 OAuth URL 所需的 request_token 和 授权地址等
 * @return {Promise<Record<'requestToken' | 'requestTokenSecret' | 'authenticationUrl', string>>}
 */
export function getTwitterRequestToken() {
    return http.post('web/third/getTwitterRequestToken', undefined, { disabledToast: true });
}

/**
 * @description Twitter 1.0 用 URL 返回的参数换取最终的 oauth_token
 * @param {Record<'requestToken' | 'oauthVerifier', string>} params
 * @return {Promise<Record<'accessToken' | 'accessTokenSecret' | 'railAccessTokenRes', string>>} params
 */
export function getTwitterOAuthToken(params) {
    return http.post('web/third/getTwitterAccessToken', params);
}

/**
 * @param {Record<'oauth_token' | 'oauth_verifier' | 'oauth_consumer_key', string> } tokenInfo
 * @return {Promise<{ userId: string; loginType: number; token: string }>}
 */
export function twitterLogin(tokenInfo, config) {
    return http.post('web/third/twitterLogin', tokenInfo, config);
}

/**
 * @description Line 用 code 换取 access_token
 */
export function getLineAccessToken(code) {
    return http.post('web/third/getLineAccessToken', code);
}

/**
 * @param {{ lineToken: string }} tokenInfo
 * @return {Promise<{ userId: string; loginType: number; token: string }>}
 */
export function lineLogin(tokenInfo, config) {
    return http.post('web/third/lineLogin', tokenInfo, config);
}

/**
 * @param {{ fbToken: string }} tokenInfo
 * @return {Promise<{ userId: string; loginType: number; token: string }>}
 */
export function facebookLogin(tokenInfo, config) {
    return http.post('web/third/fbLogin', tokenInfo, config);
}

/**
 * @param {{ googleToken: string }} tokenInfo
 * @return {Promise<{ userId: string; loginType: number; token: string }>}
 */
export function googleLogin(tokenInfo, config) {
    return http.post('web/third/googleLogin', tokenInfo, config);
}

/**
 * @param {Record<'appleUserId' | 'appleToken', string>} tokenInfo
 * @return {Promise<{ userId: string; loginType: number; token: string }>}
 */
export function appleLogin(tokenInfo, config) {
    return http.post('web/third/appleIdLogin', tokenInfo, config);
}
